import type { ReactNode } from 'react';
import { Field } from './Field';
import { FieldStatusIndicator } from './FieldStatusIndicator';

interface FieldWithStatusIndicatorProps {
  inputId?: string;
  name: string;
  children: ReactNode;
  isPending?: boolean;
  isSuccess?: boolean;
  action?: ReactNode;
  className?: string;
}

export const FieldWithStatusIndicator = ({
  inputId,
  name,
  children,
  isPending,
  isSuccess,
  action,
  className,
}: FieldWithStatusIndicatorProps) => {
  return (
    <Field
      inputId={inputId}
      name={name}
      statusIndicator={<FieldStatusIndicator isPending={isPending} isSuccess={isSuccess} />}
      action={action}
      className={className}
    >
      {children}
    </Field>
  );
};
